import MoreOutlinedIcon from '@ant-design/icons/MoreOutlined'

import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'

import TimelineNotes, { TimelineNoteCreation } from '@components/TimelineNotes'

import { useTaskNoteCreation, useTaskNotes } from '../Tasks.hooks'

export default function TaskNotesSection({ taskId, readOnly }) {
  const create = useTaskNoteCreation(taskId)
  const { data, isPending, fetchNextPage, hasNextPage, isFetchingNextPage } = useTaskNotes(taskId)

  const showLoading = isPending
  const showEmpty = !showLoading && data?.length === 0
  const showData = !showEmpty && data?.length > 0

  return (
    <Stack spacing={1}>
      <Divider>Notes</Divider>
      {!readOnly && <TimelineNoteCreation draftKey={`task-${taskId}-note`} onSend={(message) => create.mutateAsync(message)} />}
      {showLoading && <TimelineNotes.Loading />}
      {showEmpty && <TimelineNotes.Empty readOnly={readOnly} />}
      {showData && (
        <TimelineNotes>
          {data.map((note, i) => {
            return <TimelineNotes.Item key={note.id} data={note} isLast={data.length - 1 === i} />
          })}
          {hasNextPage && (
            <Button
              fullWidth
              loading={isFetchingNextPage}
              onClick={() => fetchNextPage()}
              endIcon={<MoreOutlinedIcon rotate={90} />}
              loadingPosition="end"
              sx={{ textTransform: 'none' }}
            >
              more
            </Button>
          )}
        </TimelineNotes>
      )}
    </Stack>
  )
}
